const WINDOW_BASE_URL =
  "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/projects/windows/";

//window images
export const CHL00625 = `${WINDOW_BASE_URL}CHL00625-HDR.jpg`;
export const CHL00652 = `${WINDOW_BASE_URL}CHL00652-HDR.jpg`;
export const CHL00658 = `${WINDOW_BASE_URL}CHL00658-HDR.jpg`;
export const CHL00670 = `${WINDOW_BASE_URL}CHL00670-HDR.jpg`;
export const CHL00701 = `${WINDOW_BASE_URL}CHL00701-HDR.jpg`;
export const CHL00711 = `${WINDOW_BASE_URL}CHL00711-HDR.jpg`;
export const CHL00751 = `${WINDOW_BASE_URL}CHL00751-HDR.jpg`;
export const CHL00776 = `${WINDOW_BASE_URL}CHL00776-HDR.jpg`;
export const CHL01056 = `${WINDOW_BASE_URL}CHL01056.jpg`;
export const CHL00835 = `${WINDOW_BASE_URL}CHL00835-HDR.jpg`;
export const CHL00861 = `${WINDOW_BASE_URL}CHL00861-HDR.jpg`;
export const CHL00876 = `${WINDOW_BASE_URL}CHL00876.jpg`;
export const CHL00878 = `${WINDOW_BASE_URL}CHL00878-HDR.jpg`;
export const CHL00905 = `${WINDOW_BASE_URL}CHL00905-HDR.jpg`;
export const CHL00908 = `${WINDOW_BASE_URL}CHL00908-HDR.jpg`;
export const CHL00933 = `${WINDOW_BASE_URL}CHL00933-HDR.jpg`;
export const CHL00952 = `${WINDOW_BASE_URL}CHL00952.jpg`;
export const CHL06388 = `${WINDOW_BASE_URL}CHL06388-HDR.jpg`;
export const CHL06397 = `${WINDOW_BASE_URL}CHL06397-HDR.jpg`;
export const CHL06403 = `${WINDOW_BASE_URL}CHL06403-HDR.jpg`;
export const CHL04656 = `${WINDOW_BASE_URL}CHL04656.jpg`;
export const CHL01196 = `${WINDOW_BASE_URL}CHL01196-HDR.jpg`;
export const CHL01211 = `${WINDOW_BASE_URL}CHL01211-HDR.jpg`;
export const CHL01297 = `${WINDOW_BASE_URL}CHL01297-HDR.jpg`;
export const CHL01307 = `${WINDOW_BASE_URL}CHL01307-HDR.jpg`;
export const CHL01322 = `${WINDOW_BASE_URL}CHL01322-HDR.jpg`;
export const CHL01327 = `${WINDOW_BASE_URL}CHL01327-HDR.jpg`;
export const CHL01336 = `${WINDOW_BASE_URL}CHL01336-HDR.jpg`;
export const CHL06528 = `${WINDOW_BASE_URL}CHL06528-HDR.jpg`;
export const CHL06409 = `${WINDOW_BASE_URL}CHL06409-HDR.jpg`;
export const CHL04696 = `${WINDOW_BASE_URL}CHL04696.jpg`;
export const CHL04688 = `${WINDOW_BASE_URL}CHL04688.jpg`;
export const CHL06603 = `${WINDOW_BASE_URL}CHL06603-HDR.jpg`;
export const CHL06606 = `${WINDOW_BASE_URL}CHL06606-HDR.jpg`;
export const CHL06632 = `${WINDOW_BASE_URL}CHL06632-HDR.jpg`;
export const CHL06753 = `${WINDOW_BASE_URL}CHL06753-HDR.jpg`;
export const CHL06747 = `${WINDOW_BASE_URL}CHL06747-HDR.jpg`;
export const CHL06720 = `${WINDOW_BASE_URL}CHL06720-HDR.jpg`;
export const CHL06732 = `${WINDOW_BASE_URL}CHL06732-HDR.jpg`;
export const CHL06756 = `${WINDOW_BASE_URL}CHL06756-HDR.jpg`;
export const CHL06762 = `${WINDOW_BASE_URL}CHL06762-HDR.jpg`;
export const CHL06796 = `${WINDOW_BASE_URL}CHL06796-HDR.jpg`;
export const CHL06793 = `${WINDOW_BASE_URL}CHL06793-HDR.jpg`;
export const CHL06771 = `${WINDOW_BASE_URL}CHL06771-HDR.jpg`;
export const CHL06805 = `${WINDOW_BASE_URL}CHL06805-HDR.jpg`;
export const CHL06839 = `${WINDOW_BASE_URL}CHL06839.jpg`;
export const CHL00631 = `${WINDOW_BASE_URL}CHL00631-HDR.jpg`;
export const CHL00695 = `${WINDOW_BASE_URL}CHL00695-HDR.jpg`;
export const CHL00726 = `${WINDOW_BASE_URL}CHL00726-HDR.jpg`;
export const CHL00781 = `${WINDOW_BASE_URL}CHL00781-HDR.jpg`;
export const CHL00800 = `${WINDOW_BASE_URL}CHL00800-HDR.jpg`;
export const CHL00877 = `${WINDOW_BASE_URL}CHL00877.jpg`;
export const CHL00918 = `${WINDOW_BASE_URL}CHL00918-HDR.jpg`;
export const CHL00954 = `${WINDOW_BASE_URL}CHL00954.jpg`;
export const CHL00955 = `${WINDOW_BASE_URL}CHL00955.jpg`;
export const CHL00965 = `${WINDOW_BASE_URL}CHL00965.jpg`;
export const CHL00976 = `${WINDOW_BASE_URL}CHL00976.jpg`;
export const CHL00981 = `${WINDOW_BASE_URL}CHL00981-HDR.jpg`;
export const CHL00987 = `${WINDOW_BASE_URL}CHL00987-HDR.jpg`;
export const CHL01007 = `${WINDOW_BASE_URL}CHL01007.jpg`;
export const CHL01016 = `${WINDOW_BASE_URL}CHL01016-HDR.jpg`;
export const CHL01029 = `${WINDOW_BASE_URL}CHL01029.jpg`;
export const CHL01040 = `${WINDOW_BASE_URL}CHL01040-HDR.jpg`;
export const CHL01045 = `${WINDOW_BASE_URL}CHL01045-HDR.jpg`;
export const CHL01067 = `${WINDOW_BASE_URL}CHL01067-HDR.jpg`;
export const CHL01087 = `${WINDOW_BASE_URL}CHL01087-HDR.jpg`;
export const CHL01111 = `${WINDOW_BASE_URL}CHL01111-HDR.jpg`;
export const CHL01122 = `${WINDOW_BASE_URL}CHL01122-HDR.jpg`;
export const CHL01132 = `${WINDOW_BASE_URL}CHL01132-HDR.jpg`;
export const CHL01137 = `${WINDOW_BASE_URL}CHL01137.jpg`;
export const CHL01140 = `${WINDOW_BASE_URL}CHL01140-HDR.jpg`;
export const CHL01150 = `${WINDOW_BASE_URL}CHL01150.jpg`;
export const CHL01155 = `${WINDOW_BASE_URL}CHL01155-HDR.jpg`;
export const CHL01156 = `${WINDOW_BASE_URL}CHL01156-HDR.jpg`;
export const CHL01161 = `${WINDOW_BASE_URL}CHL01161-HDR.jpg`;
export const CHL01166 = `${WINDOW_BASE_URL}CHL01166-HDR.jpg`;
export const CHL01176 = `${WINDOW_BASE_URL}CHL01176-HDR.jpg`;
export const CHL01201 = `${WINDOW_BASE_URL}CHL01201-HDR.jpg`;
export const CHL01206 = `${WINDOW_BASE_URL}CHL01206-HDR.jpg`;
export const CHL01255 = `${WINDOW_BASE_URL}CHL01255-HDR.jpg`;
export const CHL01281 = `${WINDOW_BASE_URL}CHL01281-HDR.jpg`;
export const CHL01287 = `${WINDOW_BASE_URL}CHL01287-HDR.jpg`;
export const CHL01382 = `${WINDOW_BASE_URL}CHL01382-HDR.jpg`;
export const CHL01412 = `${WINDOW_BASE_URL}CHL01412.jpg`;
export const CHL01414 = `${WINDOW_BASE_URL}CHL01414.jpg`;
export const CHL04445 = `${WINDOW_BASE_URL}CHL04445-HDR.jpg`;
export const CHL04451 = `${WINDOW_BASE_URL}CHL04451.jpg`;
export const CHL04479 = `${WINDOW_BASE_URL}CHL04479.jpg`;
export const CHL04481 = `${WINDOW_BASE_URL}CHL04481.jpg`;
export const CHL04492 = `${WINDOW_BASE_URL}CHL04492.jpg`;
export const CHL04497 = `${WINDOW_BASE_URL}CHL04497.jpg`;
export const CHL04493 = `${WINDOW_BASE_URL}CHL04493.jpg`;
export const CHL04501 = `${WINDOW_BASE_URL}CHL04501.jpg`;
export const CHL04502 = `${WINDOW_BASE_URL}CHL04502.jpg`;
export const CHL04505 = `${WINDOW_BASE_URL}CHL04505.jpg`;
export const CHL04508 = `${WINDOW_BASE_URL}CHL04508.jpg`;
export const CHL04510 = `${WINDOW_BASE_URL}CHL04510.jpg`;
export const CHL04520 = `${WINDOW_BASE_URL}CHL04520.jpg`;
export const CHL04521 = `${WINDOW_BASE_URL}CHL04521.jpg`;
export const CHL04527 = `${WINDOW_BASE_URL}CHL04527.jpg`;
export const CHL04530 = `${WINDOW_BASE_URL}CHL04530.jpg`;
export const CHL04544 = `${WINDOW_BASE_URL}CHL04544.jpg`;
export const CHL04545 = `${WINDOW_BASE_URL}CHL04545.jpg`;
export const CHL04573 = `${WINDOW_BASE_URL}CHL04573.jpg`;
export const CHL04577 = `${WINDOW_BASE_URL}CHL04577.jpg`;
export const CHL04588 = `${WINDOW_BASE_URL}CHL04588.jpg`;
export const CHL04595 = `${WINDOW_BASE_URL}CHL04595.jpg`;
export const CHL04598 = `${WINDOW_BASE_URL}CHL04598.jpg`;
export const CHL04599 = `${WINDOW_BASE_URL}CHL04599.jpg`;
export const CHL04617 = `${WINDOW_BASE_URL}CHL04617.jpg`;
export const CHL04626 = `${WINDOW_BASE_URL}CHL04626.jpg`;
export const CHL04638 = `${WINDOW_BASE_URL}CHL04638.jpg`;
export const CHL04650 = `${WINDOW_BASE_URL}CHL04650.jpg`;
export const CHL04666 = `${WINDOW_BASE_URL}CHL04666.jpg`;
export const CHL04704 = `${WINDOW_BASE_URL}CHL04704.jpg`;
export const CHL06454 = `${WINDOW_BASE_URL}CHL06454-HDR.jpg`;
export const CHL06489 = `${WINDOW_BASE_URL}CHL06489-HDR-Edit.jpg`;
export const CHL06492 = `${WINDOW_BASE_URL}CHL06492-HDR.jpg`;
export const CHL06495 = `${WINDOW_BASE_URL}CHL06495-HDR.jpg`;
export const CHL06498 = `${WINDOW_BASE_URL}CHL06498-HDR.jpg`;
export const CHL06510 = `${WINDOW_BASE_URL}CHL06510-HDR.jpg`;
export const CHL06549 = `${WINDOW_BASE_URL}CHL06549-HDR.jpg`;
export const CHL06552 = `${WINDOW_BASE_URL}CHL06552-HDR.jpg`;
export const CHL06570 = `${WINDOW_BASE_URL}CHL06570-HDR.jpg`;
export const CHL06582 = `${WINDOW_BASE_URL}CHL06582-HDR.jpg`;
export const CHL06638 = `${WINDOW_BASE_URL}CHL06638-HDR.jpg`;
export const CHL06662 = `${WINDOW_BASE_URL}CHL06662-HDR.jpg`;
export const CHL06671 = `${WINDOW_BASE_URL}CHL06671-HDR.jpg`;
export const CHL06799 = `${WINDOW_BASE_URL}CHL06799-HDR.jpg`;
export const CHL06744 = `${WINDOW_BASE_URL}CHL06744-HDR.jpg`;
export const CHL06814 = `${WINDOW_BASE_URL}CHL06814-HDR.jpg`;

// louvers images
const LOUVERS_BASE_URL =
  "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/projects/louvers/";

export const CHL01261 = `${LOUVERS_BASE_URL}CHL01261-HDR.jpg`;
export const CHL01269 = `${LOUVERS_BASE_URL}CHL01269.jpg`;
export const CHL01271 = `${LOUVERS_BASE_URL}CHL01271.jpg`;
export const CHL06653 = `${LOUVERS_BASE_URL}CHL06653-HDR.jpg`;
export const CHL06777 = `${LOUVERS_BASE_URL}CHL06777-HDR.jpg`;
export const CHL06430 = `${WINDOW_BASE_URL}CHL06430-HDR.jpg`;
export const CHL06558 = `${WINDOW_BASE_URL}CHL06558-HDR.jpg`;

// railing images
const RAILING_BASE_URL =
  "https://hlineweb-f6dwh8btedejg7fz.z03.azurefd.net//hlinefiles/HLineWeb/Projects/assets/projects/railing/";

export const CHL06504 = `${RAILING_BASE_URL}CHL06504-HDR.jpg`;
export const CHL06507 = `${RAILING_BASE_URL}CHL06507-HDR.jpg`;
export const CHL00960 = `${WINDOW_BASE_URL}CHL00960.jpg`;
export const CHL00961 = `${WINDOW_BASE_URL}CHL00961.jpg`;
export const CHL00962 = `${WINDOW_BASE_URL}CHL00962.jpg`;
export const CHL01337 = `${WINDOW_BASE_URL}CHL01337-HDR.jpg`;
export const CHL01357 = `${WINDOW_BASE_URL}CHL01357-HDR.jpg`;
export const CHL01366 = `${WINDOW_BASE_URL}CHL01366-HDR.jpg`;
export const CHL01417 = `${WINDOW_BASE_URL}CHL01417-HDR.jpg`;
export const CHL01421 = `${WINDOW_BASE_URL}CHL01421.jpg`;
export const CHL04632 = `${WINDOW_BASE_URL}CHL04632.jpg`;
export const CHL04636 = `${WINDOW_BASE_URL}CHL04636.jpg`;
export const CHL04678 = `${WINDOW_BASE_URL}CHL04678.jpg`;
